import ActionHeader from './action-header';
import ActionMenu from './action-menu';
import AdvisoryHeader from './advisory-header/container';
import AdvisoryInput from './advisory-input';
import Block from './block';
import BlockView from './block-view';
import Button from './button';
import ButtonTile from './button-tile';
import Configuration from './configuration';
import ConfigView from './configuration/config-view';
import Date from './date';
import Incrementer from './incrementer';
import InfoBubble from './info-bubble';
import Loader from './loader';
import Logo from './logo';
import Modal from './modal/container';
import ModalNavigator from './modal/navigator/container';
import MoreInfo from './more-info/container';
import Pagination from './pagination';
import Price from './price';
import Radiobuttons from './radiobuttons';
import Sidebar from './sidebar';
import Switch from './switch/container';
import Table from './table';
import TableAlternate from './table-alternate';
import View from './view';

module.exports = {
  ActionHeader,
  ActionMenu,
  AdvisoryHeader,
  AdvisoryInput,
  Block,
  BlockView,
  Button,
  ButtonTile,
  Configuration,
  ConfigView,
  Date,
  InfoBubble,
  Incrementer,
  Loader,
  Logo,
  Modal,
  ModalNavigator,
  MoreInfo,
  Pagination,
  Price,
  Radiobuttons,
  Sidebar,
  Switch,
  Table,
  TableAlternate,
  View,
};



// WEBPACK FOOTER //
// ./js/components/index.js